// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"49":"fortawesome-light-svg","198":"fortawesome-solid-svg","750":"fortawesome-svg"}[chunkId] + "." + {"49":"fcc37174","198":"9516d2fb","750":"f5ae6adf"}[chunkId] + ".chunk.js";
};